/* Keyboard support shared by the scoped AOP Hoodie and Warm Hug guides. */
(() => {
  function init() {
    const modal = document.querySelector('#PopupModal-Sizeguide:is(.sg-retro-hoodie, .sg-varsity-jacket)');
    if (!modal || modal.dataset.keyboardReady) return;
    modal.dataset.keyboardReady = 'true';
    let lastOpener;
    let wasOpen = false;

    document.querySelectorAll('.size-popup[data-id="#PopupModal-Sizeguide"]').forEach((opener) => {
      opener.setAttribute('role', 'button');
      opener.setAttribute('tabindex', '0');
      opener.setAttribute('aria-haspopup', 'dialog');
      opener.setAttribute('aria-controls', 'PopupModal-Sizeguide');
      opener.addEventListener('click', () => { lastOpener = opener; });
      opener.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          opener.click();
        }
      });
    });

    const unitButtons = modal.querySelectorAll('.sg-unit__btn');
    unitButtons.forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.unit === 'in'));
      button.addEventListener('click', () => {
        unitButtons.forEach((unit) => unit.setAttribute('aria-pressed', String(unit === button)));
      });
    });

    new MutationObserver(() => {
      const isOpen = !modal.classList.contains('hidden');
      if (isOpen && !wasOpen) modal.querySelector('.sg-close').focus({ preventScroll: true });
      if (!isOpen && wasOpen && lastOpener?.isConnected) lastOpener.focus({ preventScroll: true });
      wasOpen = isOpen;
    }).observe(modal, { attributes: true, attributeFilter: ['class'] });

    modal.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab' || modal.classList.contains('hidden')) return;
      const controls = [...modal.querySelectorAll('button, a[href], [tabindex="0"]')]
        .filter((control) => !control.disabled && control.getClientRects().length);
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
